export default __webpack_public_path__ + "static/media/mod.b6db4ed9.svg";